var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm.455-17h2.368A3.293 3.293 0 0 0 18 8.307v2.394a5.495 5.495 0 0 1-3.137-1.055v4.89c0 2.455-1.983 4.464-4.431 4.464C7.983 19 6 17.012 6 14.536c0-2.455 1.943-4.423 4.35-4.463v2.394a2.074 2.074 0 0 0-1.982 2.07c0 1.135.91 2.069 2.043 2.069 1.134 0 2.044-.934 2.044-2.07V5Z",
    fill: "currentColor"
  })));
};
export default SvgTiktok;